import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss'
import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import SettingsNavigation from "../../components/settingsNavigation";
import SettingsAccount from "../../components/settingsAccount";
import SettingsVerifyModal from "../../components/settingsVerifyModal";
import SettingsWallets from "../../components/settingsWallets";
import SettingsAddWalletModal from "../../components/settingsAddWalletModal";
import SettingsEditWalletModal from "../../components/settingsEditWalletModal";
import SettingsAllocation from "../../components/settingsAllocation";
import SettingsAllocationDetailsModal from "../../components/settingsAlocationDetailsModal";



const SettingsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const isComingSoon = useSelector(store => store.main.isComingSoon);

    const [currentTab, setCurrentTab] = useState(isComingSoon ? 'account' : 'allocation');


    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Профиль')}/>
            <SettingsNavigation currentTab={currentTab} setCurrentTab={setCurrentTab}/>
            <div className={`${Styles.contentWrap}`}>
                {currentTab === 'account' ? <SettingsAccount/> : null}
                {currentTab === 'wallets' ? <SettingsWallets/> : null}
                {currentTab === 'allocation' ? <SettingsAllocation/> : null}
                <SettingsVerifyModal/>
                <SettingsAllocationDetailsModal/>
                <SettingsAddWalletModal/>
                <SettingsEditWalletModal/>
            </div>
        </section>
    );
};

export default SettingsPage;